
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class DocumentUploadP2PReaderService {

   public static getPresignedURLForUpload(
           axiosInstance: AxiosInstance, input: ServerData.DocumentUploadP2PWebReader.GetPresignedURLForUpload$Input,
           f: (output: ServerData.DocumentUploadP2PWebReader.GetPresignedURLForUpload$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'partnerprogramapi/documentuploadp2p/get-presigned-u-r-l-for-upload',
            {params : input.toJson()}
        ).then((response) => ServerData.DocumentUploadP2PWebReader.GetPresignedURLForUpload$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getUploadedUrl(
           axiosInstance: AxiosInstance, input: ServerData.DocumentUploadP2PWebReader.GetUploadedUrl$Input,
           f: (output: ServerData.DocumentUploadP2PWebReader.GetUploadedUrl$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'partnerprogramapi/documentuploadp2p/get-uploaded-url',
            {params : input.toJson()}
        ).then((response) => ServerData.DocumentUploadP2PWebReader.GetUploadedUrl$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

